import React from 'react';

import { DefaultFormActionButtonProps } from './DefaultFormActionButton.interface';
import { NewButton } from 'app/components/NewButton';

export default function DefaultFormActionButton({
  className,
  isLoading,
  suffixIcon,
  disabled,
  title,
  onClick,
}: DefaultFormActionButtonProps) {
  return (
    <NewButton
      variant={'contained'}
      color={'primary'}
      type="submit"
      isLoading={isLoading}
      disabled={disabled}
      onClick={onClick}
      title={title}
      className={className}
      suffixIcon={suffixIcon}
    />
  );
}
